export default __webpack_public_path__ + "static/koetswit-7e91c76cb5d93e5beba50b35e3ac4de9.png";